import styled from 'styled-components';

export const $DrawerFooter = styled.div<{ $hasPadding?: boolean }>`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  position: sticky;
  bottom: ${({ $hasPadding }) => ($hasPadding ? '-2rem' : '0')};
  margin-top: auto;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};

  padding: 1rem ${({ $hasPadding }) => ($hasPadding ? '1rem' : '0')};

  border-top: 1px solid ${({ theme }) => theme.newUI.variationColors.light5};

  margin-left: ${({ $hasPadding }) => ($hasPadding ? '-2rem' : '0')};
  margin-right: ${({ $hasPadding }) => ($hasPadding ? '-2rem' : '0')};
  margin-bottom: ${({ $hasPadding }) => ($hasPadding ? '-2rem' : '0')};

  z-index: 10;
`;
